import _ from './aife-menu.module.scss'
import fonts from '../../styles/fonts.module.scss'
import React from 'react'
import {$, $$$} from '../../shared/class-name'
import {isOptionActive, isUrlActive} from '../../shared/is-url-active'
import {scrollTop} from '../../shared/scroll-top'
import {useNavigate} from 'react-router-dom'
import {useSharedStore} from '../../state/shared-store-context'
import {MenuItem} from '../../components/menu-item'
import {useIsMobile} from '../../hooks/use-is-mobile'
import {config} from '../../config'

export const AifeMenu = () => {
    const navigate = useNavigate()
    const {sharedState, actions} = useSharedStore()
    const isMobile = useIsMobile()
    const stretchMode = window.innerWidth <= 599
    return <div className={$$$(
        $(_.menuItems),
        $(_.stretch, stretchMode))}
    >{options.map((option, index) => <MenuItem
        key={index}
        index={index}
        variant={option.name}
        wide={option.wide}
        stretchMode={stretchMode}
        safeAreaHandling={true}
        className={$$$(
            $(option.className?.()),
            $(option.url?.split('/').join(' ')),
        )}
        active={isUrlActive(option.url) || isUrlActive(option.name)
            || ['about', 'void'].includes(option.name) && sharedState.highlighted === option.name
            && sharedState.homePageIntent === option.name}
        highlighted={sharedState.highlighted === option.name}
        disabled={option.disabled}
        onClick={() => !option.disabled && (() => {
            if (option.url && isUrlActive(option.url)) {
                if (['home'].includes(option.name)) {
                    if (window.scrollY < 1) {
                        if (sharedState.homePageEnabled && !sharedState.homePageIntent) actions.hideHomePage()
                        else actions.showHomePage()
                    } else {
                        actions.stopAutoscroll()
                        scrollTop()
                    }
                } else scrollTop()
            } else {
                if (['about', 'void'].includes(option.name)) {
                    actions.showHomePage(option.name)
                    actions.setHighlighted(option.name)
                } else if (['home'].includes(option.name)) {
                    if (!sharedState.initialHomeScreenPassed) actions.showHomePage()
                    navigate(`/${config.app.rootState}/${option.url}`)
                } else {
                    actions.clearHighlighted()
                    actions.hideHomePage()
                    navigate(`/${config.app.rootState}/${option.url}`)
                }
            }
        })()}
        onMouseOver={() => !option.disabled && (() => {
            if (!(sharedState.homePageEnabled && !sharedState.homePageIntent && !['home'].includes(option.name)
                && isOptionActive('home') && !isOptionActive('about') && !isOptionActive('void'))) return
            actions.stopHighlighting()
            actions.setHighlighted(option.name)
        })()}
        onMouseOut={() => !option.disabled && (() => {
            if (sharedState.homePageEnabled && !sharedState.homePageIntent && !['home'].includes(option.name)
            && isOptionActive('home') && !isOptionActive('about') && !isOptionActive('void'))
            actions.startHighlighting()
        })()}
    >
        {(isMobile ? option.shortName || option.longName || option.name : option.longName || option.name)}
    </MenuItem>)}</div>
}

export const options = [
    {
        name: "home",
        url: "____l____e____x____e____r____",
        longName: '‎لي',
        shortName: '‎لي'
    },
    // config.apps.outof195.available && {
    //     name: "outof195",
    //     url: "outof195",
    //     longName: 'outof195',
    //     shortName: '🌏︎',
    //     className: () => fonts.rozhaOne,
    //     disabled: !config.apps.outof195.enabled,
    //     wide: true
    // },
    {
        name: "999",
        url: "999/kamimodo™",
        longName: "9  9  9",
        shortName: "9  9  9",
        className: () => fonts.rozhaOne,
        wide: true
    },
    {name: "instagram", url: "instagram", longName: "7 ¥ 5", shortName: "¥"},
    {name: "soundcloud", url: "soundcloud/7", longName: "7 € X", shortName: "€"},
    {name: "spotify", url: "spotify/playlist", longName: "2 $ 7", shortName: "$"},
    {
        name: 'void',
        longName: 'खालीपन',
        shortName: 'खालीपन',
        className: () => fonts.rozhaOne,
        wide: true
    },
    {
        name: "about",
        longName: '7',
        shortName: '7',
    },
].filter(Boolean)

export const getUrlFromOption = (optionName) => options.find(option => option.name === optionName).url
export const order = [
    '999',
    'instagram',
    'soundcloud',
    'spotify',
    'void',
    'about'
]
